// extracted by mini-css-extract-plugin
export var imageWrapper = "index-module--imageWrapper--A8wja";
export var image = "index-module--image--2THIp";
export var gridItem = "index-module--gridItem--2k69y";
export var details = "index-module--details--2AsGE";